// eslint-disable-next-line no-unused-vars
import React from 'react';
import { object, func } from 'prop-types';
import { withTranslation } from 'react-i18next';

import ProductPropType from 'Types/product';
import { ProductWishlistItem } from 'Containers/Products/ProductWishlistItem';
import ProductDetailWishlistItemComponent from 'Components/Products/ProductDetailWishlistItem';
import withCart from 'AppSrc/hocs/withCart';
import withWishlist from 'AppSrc/hocs/withWishlist';
import withProducts from 'AppSrc/hocs/withProducts';
import withFetch from 'AppSrc/hocs/withFetch';
import withModals from 'AppSrc/hocs/withModals';
import withUser from 'AppSrc/hocs/withUser';
import withToastNotifications from 'AppSrc/hocs/withToastNotifications';
import withAnalytics from 'AppSrc/hocs/withAnalytics';

@withTranslation()
@withToastNotifications
@withUser
@withProducts
@withFetch
@withCart
@withWishlist
@withModals
@withAnalytics
export default class ProductDetailWishlistItem extends ProductWishlistItem {
  constructor(props) {
    super(props);
    this.handleOnDelete = this.handleOnDelete.bind(this);
    this.handleOnMoveToWishlist = this.handleOnMoveToWishlist.bind(this);
    this.handleOnChangeQuantity = this.handleOnChangeQuantity.bind(this);
  }

  async handleOnChangeQuantity(quantity) {
    const { product } = this.state;
    const { wishlistContext, parentWishlist, onChangeQty } = this.props;
    if (quantity === product.quantity) return;
    this.setState(prevState => ({
      ...prevState,
      product: {
        ...prevState.product,
        quantity
      },
      loading: true,
      error: null
    }));

    try {
      await wishlistContext.updateProduct(parentWishlist.id, {
        id: product.id || product.productId,
        quantity
      });
      onChangeQty({ ...product, quantity });
    } catch (e) {
      this.setState(prevState => ({
        ...prevState,
        error: e.message,
        product: {
          ...prevState.product,
          quantity: product.quantity
        }
      }));
    } finally {
      this.setState({ loading: false });
    }
  }

  async handleOnDelete() {
    const { product } = this.state;
    const { analytics } = this.props;
    analytics.track('deleted_product_from_wishlist', {
      product_id: product?.id,
      product_sku: product?.code,
    });
    await super.handleOnDelete();
    this.props.onChangeQty({ ...product, quantity: 0 });
  }

  async handleOnMoveToWishlist({ selectedItem }) {
    const { product } = this.state;
    await super.handleOnMoveToWishlist({ selectedItem });
    this.props.onChangeQty({ ...product, quantity: 0 });
  }

  render() {
    const { product, loading, addToCartLoading } = this.state;
    const { parentWishlist, userContext } = this.props;

    return (
      <ProductDetailWishlistItemComponent
        loading={ loading }
        wishlist={ parentWishlist }
        addToCartLoading={ addToCartLoading }
        onMoveToWishlist={ this.handleOnMoveToWishlist }
        product={ product }
        onAddToCart={ this.handleOnAddToCart }
        onDelete={ this.handleOnDelete }
        onQuickView={ this.handleOnQuickView }
        onStockAlertModalOpen={ this.handleStockAlertModalOpen }
        onChangeQuantity={ this.handleOnChangeQuantity }
        defaultCurrency={ userContext?.data?.defaultCurrency }
        withVat={ userContext?.data?.withVat }
      />
    );
  }
}

ProductDetailWishlistItem.propTypes = {
  wishlists: object,
  parentWishlist: object,
  fetch: func,
  onChangeQty: func,
  product: ProductPropType,
};

ProductDetailWishlistItem.displayName = 'ProductDetailWishlistItemContainer';
